import { Injectable } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { PopupType } from 'src/app/core/models/common.models';
import { FavoriteEventAction, IEventReview, IPopupInputForm } from '../models/passport.models';
import { PassportService } from './passport.service';

@Injectable({
  providedIn: 'root'
})
export class EventReviewService {

  constructor(private passportService: PassportService, private spinner: NgxSpinnerService) { }

  public async handleEventReviewPopup(event: IPopupInputForm): Promise<{review: IEventReview, showPopup: boolean}> {
    this.spinner.show();
    if (event.popupType === PopupType.EVENT_REVIEW && event.popupForm.voteState) {
      try {
        const response = await this.passportService.updateReviewVote(event.popupForm.eventReviewId, event.popupForm.voteState);
        this.spinner.hide();

        return {
          review: response,
          showPopup: true
        };
      } catch (e) {
        return this.handleError(e);
      }
    } else if (event.popupForm.eventReviewId) {
      try {
        const response = await this.passportService.updateEventReview(event.popupForm.eventReviewId, event.popupForm as IEventReview);
        this.spinner.hide();

        return {
          review: response,
          showPopup: true
        };
      } catch (e) {
        return this.handleError(e);
      }
    } else {
      try {
        const response = await this.passportService.saveEventReview(event.popupForm.eventId, event.popupForm as IEventReview);
        this.spinner.hide();

        return {
          review: response,
          showPopup: true
        };
      } catch (e) {
        return this.handleError(e);
      }
    }
  }

  public async handleFavoriteEventState(event: IPopupInputForm): Promise<boolean> {
    this.spinner.show();
    try {
      const response = await this.passportService.updateFavoriteEventState({
        eventId: event.popupForm.eventId,
        action: event.popupForm.favoriteState
      });
      this.spinner.hide();
      console.log(response);

      return !!response.message;
    } catch (e) {
      console.error(e);
      this.spinner.hide();

      return false;
    }
  }

  private handleError(e: any): Promise<{review: IEventReview, showPopup: boolean}> {
    console.error(e);
    this.spinner.hide();

    return Promise.resolve({
      review: null,
      showPopup: false
    });
  }
}
